import { Navigate } from 'react-router-dom';

const AboutAdmin = () => {
  return <Navigate to="/admin/pages?page=about" replace />;
};

export default AboutAdmin;
